import {ShiftEntity} from "@ots-frontend/ots-data";
import {BaseShiftTimeline, BaseShiftTimelineProps} from "./BaseShiftTimeline";
import {useGetShiftLocationHistory} from "../../../hooks/useGetShiftLocationHistory";
import {useMemo} from "react";
import {getShiftTimeline} from "../../map/LocationHistoryMap/util";
import {Box, Skeleton} from "@mantine/core";
import {Empty} from "../../empty/Empty/Empty";

export type ShiftTimelineProps = Omit<BaseShiftTimelineProps, 'timeline'> & {
  shift: ShiftEntity | string
}

export const ShiftTimeline = (props: ShiftTimelineProps) => {
  const {shift, ...rest} = props

  const {
    history,
    isLoading,
  } = useGetShiftLocationHistory({
    shift: shift,
  })

  const timeline = useMemo(() => {
    return history ? getShiftTimeline(history, undefined) : undefined
  }, [history])


  return (
    <Box>
      {isLoading &&
        <>
          <Skeleton height={50} circle mb="xl"/>
          <Skeleton height={8} radius="xl"/>
          <Skeleton height={8} mt={6} radius="xl"/>
          <Skeleton height={8} mt={6} width="70%" radius="xl"/>
        </>
      }
      {timeline ? (
        <BaseShiftTimeline
          {...rest}
          timeline={timeline}
        />
      ) : (
        <Empty
          maw={400}
          h={100}
          mx="auto"
          message={"No Timeline"}/>
      )}
    </Box>
  )
}
